import "./ResetZoom.css";
import React, { useEffect, useRef } from "react";
import Zoom from "ol/control/Zoom";
import { zoom, center } from "../../_config/map";
import restoreView_min from "../../_assets/img/restoreView_min.png";
import { vector } from "../../_config/layers/";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

function ResetZoom(props) {
  const { t } = useTranslation();

  const element = useRef();
  const restoreElement = useRef();

  useEffect(() => {
    const control = new Zoom({ className: "ol-zoom", target: element.current });
    props.map.addControl(control);


  }, []);

  const handleClick = () => {
    vector.getSource().clear();
    props.map.getView().setZoom(zoom);
    props.map.getView().setCenter(center);
  };

  return (
    <div className="ResetZoom">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t("resetZoom.alt")}
        title={t("resetZoom.title")}
        onClick={handleClick}
        ref={restoreElement}
        icon="pi pi-arrow-down-left-and-arrow-up-right-to-center"
      ></Button>
      <div ref={element} className="ResetZoomContent">
        {" "}
      </div>
    </div>
  );
}

export default ResetZoom;
